// One object per environment, picked from the hosting origin at load time (rugby-zone convention).
export const productionConfig = {
  integrationService: `${process.env.VUE_APP_INTEGRATION_SERVICE}`,
  nodeEnv: 'Prod'
}

export const developmentConfig = {
  integrationService: `${process.env.VUE_APP_DEVELOPMENT_INTEGRATION_SERVICE}`,
  nodeEnv: 'Dev'
}

export const localConfig = {
  integrationService: `${process.env.VUE_APP_LOCAL_INTEGRATION_SERVICE}`,
  nodeEnv: 'Local'
}

export const environmentConfig = getEnvObject(getEnvironment())

function getEnvironment() {
  const origin = window.location.origin
  if (origin.includes('localhost')) return 'local'
  if (origin.includes('staging') || origin.includes('dev')) return 'development'
  return 'production'
}

function getEnvObject(environment) {
  if (environment === 'local') return localConfig
  if (environment === 'development') return developmentConfig
  return productionConfig
}
